import { useTranslation } from 'react-i18next';
import { CheckCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

import s from './CompletedCell.module.scss';

import type { FC } from 'react';

interface ICompletedCellProps {
  completedByTitle: string | null;
  completedByName: string | null;
  completedByGuid: string | null;
  completedAt: string | null;
  currentUserGuid: string;
}

const CompletedCell: FC<ICompletedCellProps> = ({
  completedByTitle,
  completedByName,
  completedByGuid,
  completedAt,
  currentUserGuid,
}) => {
  const { t } = useTranslation();
  const isMe = completedByGuid === currentUserGuid;
  const displayName =
    completedByTitle && completedByName
      ? `${completedByTitle} ${completedByName}`
      : completedByName ?? '';

  return (
    <div className={s['completed-cell']} data-cy="completed-cell">
      <div className={s['completed-info']}>
        <div className={s['completed-text']}>
          <span className={s['completer-name']}>
            {displayName}
            {isMe && completedByName && (
              <span className={s['me-suffix']}>
                {' '}
                {t('tasksDashboard.reporter.me')}
              </span>
            )}
          </span>
          {(() => {
            if (!completedAt) return null;
            const parsed = dayjs(completedAt);
            if (!parsed.isValid()) return null;
            return (
              <span className={s['completed-date']}>
                {parsed.format('MM/DD/YYYY')}
              </span>
            );
          })()}
        </div>
        <CheckCircleOutlined className={s['completed-icon']} />
      </div>
    </div>
  );
};

export default CompletedCell;
